import React, { FC } from 'react'

import { IconBlogProps } from './IconBlog.types'
import * as Styled from './styles/IconBlog.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBlog: FC<IconBlogProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBlogProps['size'],
  isResponsive = false,
}: IconBlogProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='m33.063 9.86 5.062 5.058' stroke='#EA1A1A' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M37 16.02V39c0 2.21-1.79 4-4 4H11c-2.21 0-4-1.79-4-4V15c0-2.21 1.79-4 4-4h20.96'
          stroke='#fff'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M42.602 10.418 19.532 33.5l-6.571 1.64a.072.072 0 0 1-.082-.019.074.074 0 0 1-.02-.082l1.602-6.582L35.106 7.863a3.55 3.55 0 0 1 5.023-.05l2.473 2.605Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBlog
